export const taptapUseFor = {
  GAMING: 'Gaming',
  WORK_PROFESSIONAL: 'Work / Professional',
  BUSINESS: 'Business',
  SCHOOL: 'School',
  PERSONAL_USE: 'Personal Use',
  CREATIVE: 'Creative',
  NA: 'n/a'
};

export const referralSource = {
  VERBAL_COMMUNICATION: 'Word of mouth',
  FB_ADS: 'FB Ads',
  IG_ADS: 'IG Ads',
  GOOGLE_ADS: 'Google Ads',
  REDDIT_ADS: 'Reddit Ads',
  FACEBOOK: 'Facebook',
  INSTAGRAM:'Instagram'
};

export const taptapOptionsUseFor = [
	{ key: 'gaming', label: taptapUseFor.GAMING, value: taptapUseFor.GAMING },
	{ key: 'work_professional', label: taptapUseFor.WORK_PROFESSIONAL, value: taptapUseFor.WORK_PROFESSIONAL },
	{ key: 'business', label: taptapUseFor.BUSINESS, value: taptapUseFor.BUSINESS },
	{ key: 'school', label: taptapUseFor.SCHOOL, value: taptapUseFor.SCHOOL },
	{ key: 'personal_use', label: taptapUseFor.PERSONAL_USE, value: taptapUseFor.PERSONAL_USE },
	{ key: 'creative', label: taptapUseFor.CREATIVE, value: taptapUseFor.CREATIVE },
	{ key: 'n_a', label: taptapUseFor.NA, value: taptapUseFor.NA }
];

export const referralSourceOptions = [
	{ key: 'verbal_communication', label: referralSource.VERBAL_COMMUNICATION, value: referralSource.VERBAL_COMMUNICATION },
	{ key: 'facebook_ads', label: referralSource.FB_ADS, value: referralSource.FB_ADS },
	{ key: 'instagram_ads', label: referralSource.IG_ADS, value: referralSource.IG_ADS },
	{ key: 'google_ads', label: referralSource.GOOGLE_ADS, value: referralSource.GOOGLE_ADS },
	{ key: 'reddit_ads', label: referralSource.REDDIT_ADS, value: referralSource.REDDIT_ADS },
	{ key: 'facebook_social', label: referralSource.FACEBOOK, value: referralSource.FACEBOOK },
	{ key: 'instagram_social', label: referralSource.INSTAGRAM, value: referralSource.INSTAGRAM }
];
